module.exports = __webpack_public_path__ + "img/待办派单.e15298d5.png";